import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { LOCAL_STORAGE_NAME } from 'src/utils/constants';
import { auth } from 'src/utils/helper';
import {
  getItem,
  removeItem,
} from 'src/utils/localStorage';

const OAUTH_PUBLIC_PATHS = [
  '/login',
  '/loginCallback',
  '/callback',
  '/callback/dmdc',
  '/logout',
];

const isOAuthPublicPath = (pathname: string = ''): boolean => {
  return OAUTH_PUBLIC_PATHS.some(
    p => pathname === p || pathname.endsWith(p),
  );
};

export const PublicRoute = ({
  component,
  allowWhenAuthenticated,
  ...rest
}: any) => {
  return (
    <Route
      {...rest}
      render={props => {
        const pathname = props?.location?.pathname || '';
        // Luôn cho phép các trang OAuth — cookie cũ recruit-token không được đá khỏi callback
        if (
          allowWhenAuthenticated ||
          isOAuthPublicPath(pathname) ||
          !auth()
        ) {
          return React.createElement(component, props);
        }
        const url_redirect = getItem(
          LOCAL_STORAGE_NAME.URL_REDIRECT,
        );
        removeItem(LOCAL_STORAGE_NAME.URL_REDIRECT);
        return (
          <Redirect
            to={{
              pathname: url_redirect || '/',
            }}
          />
        );
      }}
    />
  );
};
